import {ComponentProps, useEffect, useState} from "react";
import { ReactComponent as SunIcon } from './assets/icons/sun.svg';
import { ReactComponent as MoonIcon } from './assets/icons/moon.svg';
import styles from './DarkModeProvider.module.scss';
import {DropDownComponent} from "./componets/common";

export const DarkModeProvider = ({ children }: ComponentProps<any>) => {
	const [loaded, setLoaded] = useState(false);
	const [isDarkMode] = useState(Boolean(window.localStorage.getItem('dark-mode')));
	useEffect(() => {
		setLoaded(true);
		if (isDarkMode) {
			document.body.classList.add('dark-mode');
		}
	}, []);
	return <>
		{!loaded && <div>Loading...</div>}
		{loaded && children}
	</>
}

export const DarkModeSwitcherMini = () => {
	const [isDarkMode, setDarkMode] = useState(Boolean(window.localStorage.getItem('dark-mode')));
	const toggleDarkMode = (val: boolean) => {
		if (val) {
			document.body.classList.add('dark-mode');
			window.localStorage.setItem('dark-mode', 'true');
		} else {
			document.body.classList.remove('dark-mode');
			window.localStorage.removeItem('dark-mode');
		}
		setDarkMode(val);
	}
	return (
		<div className={styles.rootMini}>
			<DropDownComponent
				dropdownRender={() => (
					<div className={styles.options}>
						<div
							onClick={() => toggleDarkMode(true)}
							className={`${styles.item} ${isDarkMode ? styles.active : ''}`}>
							<MoonIcon />
							<span>Dark mode</span>
						</div>
						<div
							onClick={() => toggleDarkMode(false)}
							className={`${styles.item} ${!isDarkMode ? styles.active : ''}`}>
							<SunIcon />
							<span>Light mode</span>
						</div>
					</div>
				)}
				label={
					<div className={isDarkMode ? styles.activeDark : styles.activeLight}>
						{isDarkMode ? <MoonIcon /> : <SunIcon />}&nbsp;
					</div>
				}
			/>
		</div>
	)
}

export const DarkModeSwitcher = () => {
	const [isDarkMode, setDarkMode] = useState(Boolean(window.localStorage.getItem('dark-mode')));
	const toggleDarkMode = (val: boolean) => {
		if (val) {
			document.body.classList.add('dark-mode');
			window.localStorage.setItem('dark-mode', 'true');
		} else {
			document.body.classList.remove('dark-mode');
			window.localStorage.removeItem('dark-mode');
		}
		setDarkMode(val);
	}
	return (
		<div className={styles.root}>
			<div
				onClick={() => toggleDarkMode(true)}
				className={`${styles.item} ${isDarkMode ? styles.active : ''}`}>
				<MoonIcon />
				<label>Dark mode</label>
			</div>
			<div
				onClick={() => toggleDarkMode(false)}
				className={`${styles.item} ${!isDarkMode ? styles.active : ''}`}>
				<SunIcon />
				<label>Light mode</label>
			</div>
		</div>
	)
}
